import React from "react";
import Header from "./Header";


const WebsiteFlowLayout = (props) => {
  return (
    <>
      <div className="mb-5">
        <Header />
      </div>
      {props?.children}
    </>
  );
};

export default WebsiteFlowLayout;
